module.exports = __webpack_public_path__ + "static/img/13.fb0ddc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partners/13.png
// module id = mfgD
// module chunks = 1